import { Button } from "@meiden-connect/ui";
import { useState } from "react";
import { loadTipsCollapsed, saveTipsCollapsed } from "../lib/tips-preference";

// 操作 Tips パネル（右下のミニマップ近傍）。
// デフォルトは折りたたみ表示（1 行のヒント）、クリックで展開してショートカット一覧を表示する。
export function ShortcutTipsPanel(): JSX.Element {
  const [collapsed, setCollapsed] = useState<boolean>(() => loadTipsCollapsed());
  const toggle = (): void => {
    const next = !collapsed;
    setCollapsed(next);
    saveTipsCollapsed(next);
  };

  return (
    <aside
      aria-label="操作ヒント"
      style={{
        position: "absolute",
        right: "16px",
        bottom: "168px",
        zIndex: 10,
        maxWidth: "280px",
      }}
    >
      <Button
        type="button"
        aria-expanded={!collapsed}
        onClick={toggle}
        variant="action"
        className="shortcut-tips-toggle"
      >
        {collapsed ? "❔ 操作ヒントを表示" : "❌ 操作ヒントを隠す"}
      </Button>
      {!collapsed ? (
        <ul
          style={{
            margin: "8px 0 0",
            padding: "12px",
            listStyle: "none",
            background: "var(--color-surface)",
            border: "1px solid var(--color-border)",
            borderRadius: "var(--radius-2)",
            boxShadow: "var(--shadow-1)",
            fontSize: "12px",
            color: "var(--color-text-muted)",
            lineHeight: "1.7",
          }}
        >
          <li>ドラッグ または W/A/S/D キー: キャンバス移動</li>
          <li>ホイール: 上下スクロール / Shift+ホイール: 左右</li>
          <li>Ctrl+ホイール: 拡大縮小 / Ctrl+「+」「−」: 段階ズーム</li>
          <li>Ctrl+C: 選択中の図形・テキスト・画像・リンクカードをコピー</li>
          <li>Ctrl+V: コピーしたオブジェクト / 画像 / URL をマウス位置へ貼り付け</li>
          <li>Ctrl+Z: 自分の直前操作を元に戻す</li>
          <li>Ctrl+Y: 元に戻した自分の操作をやり直す</li>
          <li>ファイルをドラッグ&ドロップで画像/動画を配置</li>
          <li>Esc: ツール解除</li>
        </ul>
      ) : null}
    </aside>
  );
}
